import type { IconProps } from '@/components/CustomIcon/types';

export const LiveLessonsIcon = ({
  size = 20,
  className,
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.20841 12.0833L12.6667 9.875C12.9167 9.70833 13.0417 9.47222 13.0417 9.16667C13.0417 8.86111 12.9167 8.625 12.6667 8.45833L9.20841 6.25C8.93064 6.06944 8.64591 6.05556 8.35425 6.20833C8.06258 6.36111 7.91675 6.60417 7.91675 6.9375V11.3958C7.91675 11.7292 8.06258 11.9722 8.35425 12.125C8.64591 12.2778 8.93064 12.2639 9.20841 12.0833ZM3.33341 15.8333C2.87508 15.8333 2.48286 15.6703 2.15675 15.3442C1.83064 15.0181 1.6673 14.6256 1.66675 14.1667V4.16667C1.66675 3.70833 1.83008 3.31611 2.15675 2.99C2.48341 2.66389 2.87564 2.50056 3.33341 2.5H16.6667C17.1251 2.5 17.5176 2.66333 17.8442 2.99C18.1709 3.31667 18.334 3.70889 18.3334 4.16667V14.1667C18.3334 14.625 18.1704 15.0175 17.8442 15.3442C17.5181 15.6708 17.1256 15.8339 16.6667 15.8333H13.3334V16.6667C13.3334 16.9028 13.2534 17.1008 13.0934 17.2608C12.9334 17.4208 12.7356 17.5006 12.5001 17.5H7.50008C7.26397 17.5 7.06619 17.42 6.90675 17.26C6.7473 17.1 6.6673 16.9022 6.66675 16.6667V15.8333H3.33341ZM3.33341 14.1667H16.6667V4.16667H3.33341V14.1667Z"
        fill="currentColor"
      />
    </svg>
  );
};
